
import { useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'
import { useLevelCalculation } from './useLevelCalculation'

interface UseProfileRealtimeProps {
  onProfileChange?: () => void
}

export const useProfileRealtime = ({ onProfileChange }: UseProfileRealtimeProps) => {
  const { calculateLevel } = useLevelCalculation()

  useEffect(() => {
    const channel = supabase
      .channel('profile-changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'profiles'
        },
        async (payload) => {
          console.log('Profile updated:', payload)
          
          // Check if points were updated and level needs to be recalculated
          if (payload.new && typeof payload.new.points === 'number') {
            const newLevel = calculateLevel(payload.new.points)
            const currentLevel = payload.new.level || 1
            
            if (newLevel !== currentLevel) {
              // Update the level in the database
              const { error } = await supabase
                .from('profiles')
                .update({ level: newLevel })
                .eq('id', payload.new.id)
              
              if (error) {
                console.error('Error updating level:', error)
              } else {
                console.log(`Level updated from ${currentLevel} to ${newLevel} for user ${payload.new.id}`)
              }
            }
          }
          
          if (onProfileChange) {
            onProfileChange()
          }
        }
      )
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [onProfileChange, calculateLevel])
}
